<template>
  <private-gym-page id="video-workouts-page" name="home" :has_fab="false">

    <f7-searchbar
        disable-button-text="Cancel"
        placeholder="Zoek een training (min 3 karakters)"
        v-model:value="query"
        :clear-button="true"
    ></f7-searchbar>

    <f7-block-title>
      Techniek trainingen
    </f7-block-title>

    <f7-list class="list-strong list-outline list-dividers">
      <video-link-item v-for="(video, index) in videos_sorted"
                       :video="video"
                       :query="query"
                       :show="videoSheetStates[index]"
                       @opened="updateVideoSheetsState(index, true)"
                       @closed="updateVideoSheetsState(index, false)"
      >
      </video-link-item>
    </f7-list>
  </private-gym-page>


</template>

<script>

import PrivateGymPage from "./../_layouts/PrivateGymPage.vue";
import {f7, f7ready, theme} from 'framework7-vue';
import VideoSheet from "../../components/videos/VideoSheet.vue";
import VideoLinkItem from "../../components/videos/VideoLinkItem.vue";
import utility from "../../js/utility";

export default {
  components: {
    VideoLinkItem,
    VideoSheet,
    PrivateGymPage,
  },

  props: {
    f7route: Object,
    f7router: Object,
    has_fab: {default: false}
  },

  setup(props) {
    const {f7route, f7router} = props;
  },

  mixins: [],

  data: function () {
    return {
      theme,
      query: '',
      videoSheetStates: [],
      videos: [
        {
          title: 'Barbell Backsquat',
          subtitle2: `Welke spier(en) train je: bovenbenen. |  Ga recht onder de barbell (stang) staan, leg deze op je schouders en til deze uit het rek. |  Voeten op heupbreedte en gebruik waar nodig een squatplateau. |  Zak door de knieën en hou hierbij je bovenlichaam recht overeind. | Kom omhoog door kracht te leveren met je bovenbenen.`,
          src: 'https://volcano-storage.ams3.digitaloceanspaces.com/private-gym/embeded/Barbell%20backsquat.mp4'
        },
        {
          title: "Barbell Deadlift",
          subtitle2: 'Welke spier(en) train je: achterkant bovenbenen, billen, onderrug | Hou je voeten heupbreedte en houd de stang iets breder vast dan heupbreedte. | Hou bij het zakken en tillen je rug recht en schouderbladen naar elkaar toe getrokken. | Houd je knieën achter de stang en beweeg je heupen naar achteren en naar voren om de stang omhoog en omlaag te tillen.',
          src: "https://volcano-storage.ams3.digitaloceanspaces.com/private-gym/embeded/Barbell%20deadlift.mp4"
        },
        {
          title: "Bi-cep Curl (cable)",
          subtitle2: 'Welke spier(en) train je: Voorkant bovenarm | Bevestig de kleine stang op het laagste punt van de kabel | Pak de stang onderhands vast. | Sta rechtop en breng de stang naar je borst door je armen te buigen. | Houd spanning bij het strekken van je armen',
          src: "https://volcano-storage.ams3.digitaloceanspaces.com/private-gym/embeded/Bicepcurl%20%28cable%29.mp4"
        },
        {
          title: "Chest fly (cable)",
          subtitle2: 'Welke spier(en) train je: borst | Hang de beide kabels op borsthoogte. | Houd je armen licht gebogen tot bijna gestrekt tijdens de oefening. | Breng beide handvatten naar elkaar toe tot borsthoogte | Houd spanning op de weg terug.',
          src: "https://volcano-storage.ams3.digitaloceanspaces.com/private-gym/embeded/Chest%20fly%20%28cable%29.mp4"
        },
        {
          title: "Lat pulldown (wide grip)",
          subtitle2: 'Welke spier(en) train je: Grote rugspier, bovenkant- en zijkant rug | Pak de stang breed vast en ga op een plat bankje zitten met je knieën onder de rol. | Hang ligt naar achter. | Zet je bovenlichaam vast tijdens de herhaling. | Trek de stang naar borsthoogte en strek je armen hierna volledig.',
          src: "https://volcano-storage.ams3.digitaloceanspaces.com/private-gym/embeded/Lat%20pulldown%20%28wide%20grip%29.mp4"
        },
        {
          title: "Tricep pushdown (cable)",
          subtitle2: 'Welke spier(en) train je: Achterkant bovenarm | Hang het touw aan de kabel op de hoogste stand. | Je ellebogen wijzen omlaag bij elke herhaling. | Beweeg alleen met je onderarmen. | Trek het touw omlaag tot je armen gestrekt zijn.', 
          src: "https://volcano-storage.ams3.digitaloceanspaces.com/private-gym/embeded/Tricep%20pushdown%20%28cable%29.mp4"
        },
        // {
        //   title: "Quick Workout #04",
        //   subtitle: 'Trojan Pose Kettlebell Deadlift & Goblet Squat',
        //   src: "https://iframe.mediadelivery.net/embed/92295/426632b8-faea-4755-8ad8-73ba7fa51957"
        // },
        // {
        //   title: "Boxing Workout Demo",
        //   subtitle: '',
        //   src: "https://iframe.mediadelivery.net/embed/92295/dc5796de-c6c8-405a-a42f-0e4f01038fb8"
        // },
        // {
        //   title: "Boxing Workout Niveau 1",
        //   subtitle: '',
        //   src: "https://iframe.mediadelivery.net/embed/92295/0bbc9448-e480-4947-a358-7b020c27a0dd"
        // },
        // {
        //   title: "Boxing Workout Niveau 2",
        //   subtitle: '',
        //   src: "https://iframe.mediadelivery.net/embed/92295/d561fb56-d778-4785-b2c6-6f4a4c03372e"
        // },
        // {
        //   title: "Boxing Workout Niveau 3",
        //   subtitle: '',
        //   src: "https://iframe.mediadelivery.net/embed/92295/76e654f5-f95f-44db-8861-8f700ff1b579"
        // },
        // {
        //   title: 'Quick Workout #05',
        //   subtitle: "Trojan Pose - Air Squats - Assault Bike",
        //   src: "https://iframe.mediadelivery.net/embed/92295/5d4926e9-ac65-4258-8e12-4eef782f2ced"
        // },
        // {
        //   title: 'Quick Workout #06',
        //   subtitle: "Knee To Elbow Hold - One Leg Hip Thruster - Alternating Chest Press",
        //   src: "https://iframe.mediadelivery.net/embed/92295/18bf8741-5c76-41c0-a81c-200b8456cdd5"
        // },
        // {
        //   title: 'Quick Workout #07',
        //   subtitle: "Suitcase Hold - Suitcase Deadlift - Farmerswalk",
        //   src: "https://iframe.mediadelivery.net/embed/92295/b3f4b68c-665c-4c7e-a644-d110ad1ab473"
        // },
        // {
        //   title: 'Quick Workout #08',
        //   subtitle: "High Plank Hold - High To Low Plank - Alternating Chest Press",
        //   src: "https://iframe.mediadelivery.net/embed/92295/185c415f-2b57-45c8-8868-8b34cded7a42"
        // },
        // {
        //   title: 'Quick Workout #09',
        //   subtitle: "Cup Hold - Goblet Squat - Reverse Lunge",
        //   src: "https://iframe.mediadelivery.net/embed/92295/cc7de276-1405-4d4d-90b9-326275bb8bf0"
        // },
        // {
        //   title: 'Quick Workout #10',
        //   subtitle: "Suitcase Hold - Alternating Lunge - Arnold Press",
        //   src: "https://iframe.mediadelivery.net/embed/92295/1dd3d5c4-bd9e-4f06-9fc8-ee74c463564d"
        // },
      ],
      myPhotoBrowserVideo: null,
    };
  },

  computed: {
    current_user() {
      return this.$store.state.current_user.data;
    },
    is_logged_in() {
      return this.$store.getters['current_user/token'].length > 0;
    },
    videos_sorted() {
      return utility.sortObjectByKey(this.videos, 'title');
    },
  },

  created() {
    //
  },

  mounted() {
    this.setVideoSheetsState();
  },

  methods: {
    openVideo() {
      this.myPhotoBrowserVideo.open();
    },
    setVideoSheetsState() {
      this.videos.forEach((video, index) => {
        this.videoSheetStates.push(false);
      })
    },
    updateVideoSheetsState(index, state) {
      this.videoSheetStates[index] = state;
    }
  },

  watch: {
    //
  }
};
</script>
<style>

</style>
